import { createSlice } from "@reduxjs/toolkit";
import { AsyncAppThunk } from "store/application-state";
import { showLoaderWhile } from "./ui";
import { getDashboardStatisticsService } from "services/crosspay-service";
import { DashboardStatisticsModel } from "libs/models/dashboard-statistics";

export interface DashboardStore {
    dashboardStatisticsData: DashboardStatisticsModel;
}

export const initialState: DashboardStore = {
    dashboardStatisticsData: {
        salesVolume: [],
        revenue: [],
        productDistribution: [],
        averageRedemptionValue: [],
        salesVolumeByLocation: [],
        redemptionVolumeByLocation: [],
        transactionCount: 0,
        totalTransactionsAmount: 0,
        cardSoldCount: 0,
        redeemedCardsCount: 0,
    },
};

const slice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardStatisticsData: (state, action) => {
      state.dashboardStatisticsData = action.payload;
    },
  },
});

export const { setDashboardStatisticsData } = slice.actions;

export const reducer = slice.reducer;
export const getDashboardStatisticsData =
  (): AsyncAppThunk =>
  async (dispatch, store) => {
    dispatch(
      showLoaderWhile(async () => {
        const apiResponse = await getDashboardStatisticsService();
        if (
          apiResponse &&
          Object.keys(apiResponse).length > 0 &&
          apiResponse.result !== null
        ) {
          dispatch(setDashboardStatisticsData(apiResponse.result));
        }
      })
    );
  };
